import Base from "./Base";
import {str2Date} from "../../filter/time";
import Filter from "./Filter";




export default function BaseEntity() {

	//extend Base's Attributes.
	Base.call(this, arguments);

	this.id = 0;
	this.sort = null;
	this.createTime = null;
	this.updateTime = null;
	this.deleted = false;

}

//extend Base's methods.
BaseEntity.prototype = new Base();
BaseEntity.prototype.constructor = BaseEntity;

//This is just a intermedia method.
BaseEntity.prototype.render = function (obj, one2one = false) {

	Base.prototype.render.call(this, obj);
	this.createTime = str2Date(this.createTime);
	this.updateTime = str2Date(this.updateTime);

}

//获取过滤器，必须每次动态生成，否则会造成filter逻辑混乱。
BaseEntity.prototype.getFilters = function () {
	return [
		new Filter("SORT", "ID", "orderId")
	];
};

BaseEntity.prototype.getForm = function () {
	console.error("you should override this base method.");
}

BaseEntity.prototype.validate = function () {
	console.error("you should override this base method.");
}

//common http detail methods.
BaseEntity.prototype.httpDetail = function (successCallback, errorCallback) {

	let that = this;
	if (!this.id) {

		this.errorMessage = "没有详情！";

		this.defaultErrorHandler(this.errorMessage, errorCallback);

		return;
	}

	let url = this.URL_DETAIL.replace("{id}", this.id);


	if (!url) {
		return;
	}

	this.httpGet(url, {}, function (response) {

		that.render(response.data[that.TAG]);

		successCallback && successCallback(response);

	}, errorCallback);

}


BaseEntity.prototype.httpSave = function (successCallback, errorCallback) {

	let that = this;

	let url = this.URL_CREATE;
	if (this.id) {
		url = this.URL_EDIT;
	}


	if (!this.validate()) {

		that.defaultErrorHandler(this.errorMessage, errorCallback);
		return;
	}


	this.httpPost(url, this.getForm(), function (response) {

		that.render(response.data[that.TAG]);

		successCallback && successCallback(response);


	}, errorCallback);

}

BaseEntity.prototype.httpDel = function (successCallback, errorCallback) {

	let that = this;
	if (!this.id) {

		this.errorMessage = "没有id，无法删除！";
		that.defaultErrorHandler(this.errorMessage, errorCallback);

		return;
	}

	let url = this.URL_DEL.replace("{id}", this.id);

	if (!url) {
		return;
	}

	this.httpPost(url, {}, function (response) {

		successCallback && successCallback(response);

	}, errorCallback);

}




// WEBPACK FOOTER //
// ./src/common/model/base/BaseEntity.js